import { View } from 'react-native'

import { ExternalLinkIcon } from '../../../components/ui/ExternalLinkIcon'
import { symbolName } from '../../../components/ui/Icon'
import { PrivacyPolicyIcon } from '../../../components/ui/PrivacyPolicyIcon'
import { SettingsCard, SettingsRow } from './SettingsPrimitives'

type LegalLinksCardProps = {
  termsOfServiceText: string
  privacyPolicyText: string
  onOpenTermsOfService: () => void
  onOpenPrivacyPolicy: () => void
}

export function LegalLinksCard({
  termsOfServiceText,
  privacyPolicyText,
  onOpenTermsOfService,
  onOpenPrivacyPolicy,
}: LegalLinksCardProps) {
  return (
    <SettingsCard className="mb-6">
      <SettingsRow
        icon={symbolName('doc.text', 'description')}
        label={termsOfServiceText}
        onPress={onOpenTermsOfService}
        accessory="external"
        accessoryIcon={<ExternalLinkIcon />}
        isLast
      />
      <View className="h-0 border-b border-border/80" />
      <SettingsRow
        leadingIcon={<PrivacyPolicyIcon />}
        label={privacyPolicyText}
        onPress={onOpenPrivacyPolicy}
        accessory="external"
        accessoryIcon={<ExternalLinkIcon />}
        isLast
      />
    </SettingsCard>
  )
}
